<template>
  <div am-cell>
    <slot></slot>
    <div am-gradient="right"></div>
    <div am-gradient="bottom"></div>
  </div>
</template>

<script>
export default {
  name: 'TableCell'
}
</script>

<style lang="scss">
[am-cell] {
  position: relative;
  box-sizing: border-box;
  padding-top: var(----spacing);
  padding-left: var(----spacing);
  border-right: var(--border-right-width) var(--border-style) var(--border-color);
  border-top: var(--border-top-width) var(--border-style) var(--border-color);

  [am-gradient] {
    position: absolute;
  }
  [am-gradient~="bottom"] {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0.5rem;
  }
  [am-gradient~="right"] {
    right: 0;
    top: 0;
    width: 0.5rem;
    height: 100%;
  }
  &:focus-visible {
    outline: none;
  }
}

[am-col~='sticky'] {
  position: sticky;
  left: 0;
  right: 0;
  z-index: 2;
}
[am-col~='sticky'][am-editing] {
  z-index: 3;
}

.-dark {
  [am-cell] { background-color: var(--color--dark); }
  [am-gradient~="bottom"] { background: linear-gradient(0deg, var(--color--dark) 0%, transparent 100%); }
  [am-gradient~="right"] { background: linear-gradient(-90deg, var(--color--dark) 0%, transparent 100%); }
}
.-light {
  [am-cell] { background-color: var(--color--white); }
  [am-gradient~="bottom"] { background: linear-gradient(0deg, var(--color--white) 0%, transparent 100%); }
  [am-gradient~="right"] { background: linear-gradient(-90deg, var(--color--white) 0%, transparent 100%); }
}
</style>
